// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3w3nd","Logo":"Toolbar_Logo__7j6-5","DesktopOnly":"Toolbar_DesktopOnly__22gvQ"};